import $vuetify from 'vuetify/es5/locale/pt';

export default {
  $vuetify,
};
